export default __webpack_public_path__ + "static/media/0c30cba8-9b4b-413e-a35d-1f5bfeb58360.ef23d9eb.jpg";